import React, { useState, useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { getUserByActivationKey, postUserPasswordByActivationKey } from '../../../api/UserApi';
import { AppRoutes } from '../../../AppRoutes';
import AdnMessageError from '../../common/adnMessage/AdnMessageError';
import AdnMessageSuccess from '../../common/adnMessage/AdnMessageSuccess';
import { appTitle } from '../../common/GeneralConfigurations';
import RecoverPageForm from './RecoverPageForm';

function ManageRecoverPage() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true)
  const [submitLoading, setSubmitLoading] = useState(false)
  const recover = window.location.pathname.includes(AppRoutes.recover.path)
  const title = recover ? "Recover Password" : "Account Activation";

  const checkToken = async () => {
    try {
      const res = await getUserByActivationKey(searchParams.get('token'))
      if (res.status === 400 || res.status === 404 || res.data.hasPassword !== recover) {
        navigate(AppRoutes.login.path)
        return
      }
      setLoading(false)
    } catch (e) {
      navigate(AppRoutes.login.path);
    }
  }

  useEffect(() => {
    checkToken()
    document.title = `${appTitle} - ${title}`;

  }, [])

  const handleRecover = async (values) => {
    setSubmitLoading(true)
    await postUserPasswordByActivationKey(searchParams.get('token'), values.password, values.passwordConfirmation)
      .then(res => {
        if (res.status === 200) {
          AdnMessageSuccess("Password recovered with success.");
          navigate(AppRoutes.login.path);
        }
      }).catch(() => {
        AdnMessageError("Could not recover password. Please contact the support.");
      }).finally(() => {
        setSubmitLoading(false);
      })
  }

  return <div>
    <RecoverPageForm
      handleRecover={handleRecover}
      loading={loading}
      title={title}
      submitLoading={submitLoading}
    />
  </div>;
}

export default ManageRecoverPage;

